import React from 'react'
import { Container, Breadcrumb, Meta, User } from '../../../components'
import routes from './routes'
import { useLocation } from 'react-router-dom'
import { viewportBreakpoint, useViewport } from '../../../utils'
import { ShareButtons } from './share-buttons'
// import { ActionButtons } from './action-buttons'

const TypeVideo = () => {
  const location  = useLocation()
  const special = location.search.includes('special')

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const height = isMobile ? 220 : 355

  return (
    <Container className="py-5 lg:py-20" color="#f5f5f5">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-6/12 px-4 lg:pr-8 mb-5 lg:mb-0">
          <iframe className="w-full" height={height} src="https://www.youtube.com/embed/-7__-sTJ7T0" frameBorder="0" allowfullscreen title="placeholde video"></iframe>
        </div>
        <div className="lg:w-6/12 px-4">
          <div className="mb-4">
            <Breadcrumb routes={routes} />
          </div>
          <div className="lg:hidden">
            <div className="text-xs font-bold mb-3">Fri, Aug 14 2020  - Sun, Aug 16 2020 </div>
          </div>
          {
            special &&
            <div className="rounded px-1 text-white text-xs mb-4 inline-block" style={{background: '#FF5448'}}>Special Resource</div>
          }
          <h1 className="text-2xl lg:text-4xl font-bold font-primary mb-5 leading-tight">Mau Data Organissasi Tersusun Rapi? Tonton Video Ini!</h1>
          <div className="w-3/4 lg:w-full flex flex-wrap -mx-2 lg:-mx-4 lg:mb-8">
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Type"
                value="Video"
              />
            </div>
            {/* <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Suitable for"
                value="Educator, Donor, Professionals"
              />
            </div> */}
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Approach"
                value="Pencegahan"
              />
            </div>
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-6 lg:mb-0"
                label="Issues"
                value="Pemuda, Pelajar"
              />
            </div>
          </div>
          <div className="mb-6 lg:mb-8">
            <User name="AIPJ2"/>
          </div>
          <hr className="my-6 lg:my-10" style={{ borderColor: '#ddd' }}/>
          <div className="text-gray-444 mb-8 lg:mb-10 text-sm">
            <p className="mb-4">
            Platform K-HUB bertujuan menciptakan platform yang menghubungkan dan mengkonsolidasikan pengetahuan mengenai ekstremisme kekerasan untuk para pemangku kepentingan, seperti Organisasi Non-Pemerintah atau Organisasi Masyarakat Sipil, dan Pemerintah Indonesia.
            </p>
            <p>
            Melalui K-HUB para pemangku kepentingan dapat berbagi praktik terbaik, pembelajaran, dan pengalaman dalam bentuk modul, infografik, buku, video, laporan, dan penelitian untuk memperkuat pemahaman yang lebih baik, menginformasikan kepada pembuat kebijakan dalam upaya mencegah ekstremisme kekerasan (PVE).
            </p>
          </div>

          {/* <ActionButtons /> */}

          <hr className="my-8 lg:my-10"/>
          <ShareButtons />
        </div>
      </div>
    </Container>
  )
}

export { TypeVideo }